
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...dynamic-slug]",
      function () {
        return require("private-next-pages/[...dynamic-slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...dynamic-slug]"])
      });
    }
  